import {useCallback, useState} from 'react';
import {isFullScreen} from '@netx/core-next/utils/browser';
import {useDocumentEvent} from './useDocumentEvent';

/**
 * Listen for full screen changes
 * @returns `true` if in full screen
 * @example
 * ```tsx
 * const isInFullScreen = useIsInFullScreen();
 * if (isInFullScreen) {
 *   // do something
 * }
 * ```
 */
export const useIsInFullScreen = () => {
	const [isInFullScreen, setIsInFullScreen] = useState(isFullScreen());

	useDocumentEvent(
		'fullscreenchange',
		useCallback(() => {
			setIsInFullScreen(isFullScreen());
		}, []),
	);

	return isInFullScreen;
};
